<template>
    <div style="border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
        <div class="row">
            <div class="col-6">
                <h4 class="card-title pb-2 pt-2 mb-0">WFO/WFH Pegawai</h4>
            </div>
            <div class="col-2 pt-2 text-right">
                <span class="pt-2">Search by</span>
            </div>
            <div v-if="admin == 'Y'" class="col-2">
                <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataFilter" class="form-control" v-model="selectedFilter" placeholder="Pilih Tim"></model-select>
            </div>
            <div class="col-2">
                <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataFilterDate" class="form-control" v-model="selectedFilterDate" placeholder="Pilih Filter"></model-select>
            </div>
        </div>
        <div class="row no-gutters">
            <div class="col-md-1">
                <hr class="border-primary"/>
            </div>
            <div class="col-md-11">
                <hr/>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-7">
                <input type="text"
                    class="form-control"
                    v-model="inputSearch"
                    :placeholder="placeHolders"
                >
            </div>
            <div v-if="selectedFilterDate.value == 'T'" class="col-3">
                <input class="form-control" type="date" v-model="date"/>
            </div>
            <div v-if="selectedFilterDate.value == 'B'" class="col-3">
                <month-picker-input placeholder="Bulan, Tahun" :no-default="true" :show-year="true" :default-year="dates.year" @change="showDate"></month-picker-input>
            </div>
            <div class="col-2">
                <CButton @click="getDataPegawai()" type="button" class="w-100 btn btn-primary">Cari</CButton>
            </div>
        </div>
        <div class="row no-gutters mt-3">
            <div class="col-2">
                <CButton v-if="datas.length != 0" @click="exportXLS()" color="success" variant="outline">Export Excel</CButton>
            </div>
            <div class="col-4"></div>
            <div class="col-6">
                <span style="float:right">
                    <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                </span>
                <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
            </div>
        </div>
        <div class="row no-gutters mt-3">
            <table class="table w-100 table-responsive table-bordered table-light table-hover" style="border-color:gainsboro!important">
                <thead>
                    <tr class="text-center">
                        <th :style="datas.length == 0&&'min-width:400px'" style="border-color:gainsboro!important" rowspan="2">Nama {{namaTipe}}</th>
                        <th style="border-color:gainsboro!important" rowspan="2">Total Pegawai</th>
                        <th style="border-color:gainsboro!important" rowspan="2">Total Presensi</th>
                        <th style="border-color:gainsboro!important" colspan="2">Tidak Presensi</th>
                        <th style="border-color:gainsboro!important" colspan="2">Izin/Cuti/Dinas</th>
                        <th style="border-color:gainsboro!important" colspan="2">Work From Home</th>
                        <th style="border-color:gainsboro!important" colspan="2">Work From Office</th>
                    </tr>
                    <tr class="text-center">
                        <th style="border-color:gainsboro!important">Jumlah</th>
                        <th style="border-color:gainsboro!important">Persentase</th>
                        <th style="border-color:gainsboro!important">Jumlah</th>
                        <th style="border-color:gainsboro!important">Persentase</th>
                        <th style="border-color:gainsboro!important">Jumlah</th>
                        <th style="border-color:gainsboro!important">Persentase</th>
                        <th style="border-color:gainsboro!important">Jumlah</th>
                        <th style="border-color:gainsboro!important">Persentase</th>
                    </tr>
                </thead>
                <tbody v-if="datas.length != 0">
                    <tr title="Click for Detail" @click="showModal(index)" style="cursor:pointer" v-for="(item, index) in datas" :key="index">
                        <td style="border-color:gainsboro!important" class="font-weight-bold">{{item.namaUnit}}</td>
                        <td style="border-color:gainsboro!important" class="text-center text-primary font-weight-bold">{{item.totalPegawai}}</td>
                        <td style="border-color:gainsboro!important" class="text-center">{{item.totalAbsen}}</td>
                        <td style="border-color:gainsboro!important" class="text-center">{{item.totalTidakAbsen}}</td>
                        <td style="border-color:gainsboro!important" class="text-center text-danger font-weight-bold">{{item.persenTidakAbsen}}</td>
                        <td style="border-color:gainsboro!important" class="text-center">{{item.totalTidakMasuk}}</td>
                        <td style="border-color:gainsboro!important" class="text-center text-danger font-weight-bold">{{item.persenTidakMasuk}}</td>
                        <td style="border-color:gainsboro!important" class="text-center">{{item.wfh}}</td>
                        <td style="border-color:gainsboro!important" class="text-center text-success font-weight-bold">{{item.persenWfh}}</td>
                        <td style="border-color:gainsboro!important" class="text-center">{{item.wfho}}</td>
                        <td style="border-color:gainsboro!important" class="text-center text-warning font-weight-bold">{{item.persenWfo}}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="9" class="text-center" style="border-color:gainsboro!important">
                            {{errMessage}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <CModal
            size="xl"
            :centered="true"
            color="white"
            :show.sync="detailModal"
            :closeOnBackdrop="false"
        >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Detail WFH/WFO {{titleModal}} {{date}}</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="detailModal = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow class="mb-3">
                        <CCol sm="12">
                            <div v-if="totalSemua != 0" id="chart">
                                <apexchart type="donut" height="330" v-if="status == true" :options="chartOptions" :series="series"></apexchart>
                            </div>
                            <div v-if="totalSemua == 0" class="mt-5 text-center">
                                Maaf, Data Tidak Ditemukan
                            </div>
                            <div v-if="totalSemua != 0" class="row no-gutters">
                                <div class="col-12">
                                    <div class="row no-gutters">
                                        <div class="col-2">
                                            <span style="text-size: 16px;color: black" class="font-weight-bold"><u>
                                                Data Detail
                                                </u>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="row mt-2 no-gutters">
                                        <div class="col-2">
                                            <span style="text-size: 12px;color: black" class="font-weight-bold">
                                                Semua Data
                                            </span>
                                        </div>
                                        <div class="col-2">
                                            <span style="float:left">
                                                {{separators(totalSemua)}} Pegawai
                                            </span>
                                        </div>
                                        <div class="col-1">
                                            <img v-if="totalSemua != 0" @click="getDownload('semua')" style="float:left;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                                        </div>
                                    </div>
                                    <div class="row mt-1 no-gutters">
                                        <div class="col-2">
                                            <span style="text-size: 12px;color: black" class="font-weight-bold">
                                                Data Work From Office
                                            </span>
                                        </div>
                                        <div class="col-2">
                                            <span style="float:left">
                                                {{separators(totalWfo)}} Pegawai
                                            </span>
                                        </div>
                                        <div class="col-1">
                                            <img v-if="totalWfo != 0" @click="getDownload('wfo')" style="float:left;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                                        </div>
                                    </div>
                                    <div class="row mt-1 no-gutters">
                                        <div class="col-2">
                                            <span style="text-size: 12px;color: black" class="font-weight-bold">
                                                Data Work From Home
                                            </span>
                                        </div>
                                        <div class="col-2">
                                            <span style="float:left">
                                                {{separators(totalWfh)}} Pegawai
                                            </span>
                                        </div>
                                        <div class="col-1">
                                            <img v-if="totalWfh != 0" @click="getDownload('wfh')" style="float:left;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                                        </div>
                                    </div>
                                    <div class="row mt-1 no-gutters">
                                        <div class="col-2">
                                            <span style="text-size: 12px;color: black" class="font-weight-bold">
                                                Data Tidak Presensi
                                            </span>
                                        </div>
                                        <div class="col-2">
                                            <span style="float:left">
                                                {{separators(totalTidakPresensi)}} Pegawai
                                            </span>
                                        </div>
                                        <div class="col-1">
                                            <img v-if="totalTidakPresensi != 0" @click="getDownload('tidakPresensi')" style="float:left;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                                        </div>
                                    </div>
                                    <div class="row mt-1 no-gutters">
                                        <div class="col-2">
                                            <span style="text-size: 12px;color: black" class="font-weight-bold">
                                                Data Izin/Cuti/Dinas
                                            </span>
                                        </div>
                                        <div class="col-2">
                                            <span style="float:left">
                                                {{separators(totalLeave)}} Pegawai
                                            </span>
                                        </div>
                                        <div class="col-1">
                                            <img v-if="totalLeave != 0" @click="getDownload('leave')" style="float:left;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CCol>
                    </CRow>
                    <CRow class="mb-3 mt-2">
                        <CCol sm="12">
                            <CButton @click="detailModal = false" color="primary" variant="outline" style="float:right" class="btn mr-2">Kembali</CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</template>

<script>
import {DataApi} from "../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { MonthPickerInput } from 'vue-month-picker'

const xlsx = require('json-as-xlsx')
export default {
    components: {
        ModelSelect,
        MonthPickerInput
    },
    data() {
        return {
            detailModal: false,
            titleModal: '',


            dataFilter: [],
            selectedFilter: {
                text: 'Divisi',
                value: '1',
            },
            dataFilterDate: [],
            selectedFilterDate: {
                text: 'Harian',
                value: 'T',
            },
            inputSearch: '',
            date: '',
            placeHolders: 'Cari Divisi / Vice President / General Manager',
            closeIcon: require('../../assets/menu/icon_close.svg'),
            downloadIcon: require('../../assets/menu/icon_download_excel.svg'),
            admin: '',
            namaTipe: 'Divisi',

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            datas: [],

            status: false,
            date: '',
            series: [0, 0, 0],
            chartOptions: {
                chart: {
                width: 330,
                type: 'donut',
                dropShadow: {
                    enabled: true,
                    color: '#111',
                    top: -1,
                    left: 3,
                    blur: 3,
                    opacity: 0.2
                }
                },
                stroke: {
                width: 0,
                },
                plotOptions: {
                pie: {
                    donut: {
                        labels: {
                            show: true,
                            total: {
                                showAlways: true,
                                show: true,
                                formatter: function (w) {
                                    let vals = w.globals.seriesTotals
                                    var i = 0
                                    let totals = 0
                                    for(i=0;i<vals.length;i++) {
                                        totals += vals[i]
                                    }
                                    let val = totals.toString()
                                    let leng = val.length
                                    let sisa 	= leng % 3
                                    let rupiah 	= val.substr(0, sisa)
                                    let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                                        
                                    if (ribuan) {
                                        let separator = sisa ? '.' : ''
                                        rupiah += separator + ribuan.join('.')
                                    }
                                    return rupiah
                                }
                            },
                            name: {
                                show: true,
                                formatter: function (val) {
                                    return val
                                }
                            },
                            value: {
                                show: true,
                                formatter: function (val) {
                                    let value = val.toString()
                                    let leng = value.length
                                    let sisa 	= leng % 3
                                    let rupiah 	= value.substr(0, sisa)
                                    let ribuan 	= value.substr(sisa).match(/\d{3}/g)
                                        
                                    if (ribuan) {
                                        let separator = sisa ? '.' : ''
                                        rupiah += separator + ribuan.join('.')
                                    }
                                    return rupiah
                                }
                            },
                        },
                    }
                }
                },
                labels: ['Work From Office', 'Work From Home', 'Tidak Presensi', 'Izin/Cuti/Dinas'],
                dataLabels: {
                dropShadow: {
                    blur: 3,
                    opacity: 0.8
                }
                },
                states: {
                hover: {
                    filter: 'none'
                }
                },
                responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                    width: 200
                    },
                    legend: {
                    position: 'bottom'
                    }
                }
                }],
            },
            totalSemua: 0,
            totalWfo: 0,
            totalTidakPresensi: 0,
            totalWfh: 0,
            totalLeave: 0,
            dataWfo: [],
            dataWfh: [],
            dataTidakPresensi: [],
            dataLeave: [],

            dates: {
                from: null,
                to: null,
                month: null,
                monthIndex: null,
                year: null
            },
            tanggal: new Date(),

            errMessage: '',
            flagSearch: false
        }
    },
    watch: {
        page() {
            this.getDataPegawai()
        },
        selectedFilter() {
            if(this.selectedFilter.value == '1') {
                this.placeHolders = 'Cari Divisi / Vice President / General Manager'
                this.namaTipe = 'Divisi'
            } else if(this.selectedFilter.value == '2') {
                this.placeHolders = 'Cari Bidang / Manager'
                this.namaTipe = 'Bidang'
            } else if(this.selectedFilter.value == '3') {
                this.placeHolders = 'Cari Kantor'
                this.namaTipe = 'Kantor'
            } else if(this.selectedFilter.value == '') {
                this.placeHolders = 'Search'
                this.namaTipe = 'Tim'
            } else if(this.selectedFilter.value == '4') {
                this.placeHolders = 'Cati Sub Bidang / Supervisor'
                this.namaTipe = 'Sub Bidang'
            }
            this.inputSearch = ''
            this.datas = []
            this.flagSearch = true
            this.getDataPegawai()
        },
        date() {
            this.flagSearch = true
        },
        selectedFilterDate() {
            if(this.selectedFilterDate.value == 'T') {
                this.dates = {
                    from: null,
                    to: null,
                    month: null,
                    monthIndex: null,
                    year: null
                }
                this.tanggal= new Date()
            } else if(this.selectedFilterDate.value == 'B') {
                this.setDate()
                this.date = ''
            }
            this.datas = []
            this.flagSearch = true
            this.getDataPegawai()
        },
        dates() {
            this.flagSearch = true
        },
        inputSearch() {
            this.flagSearch = true
        }
    },
    methods: {
        getDataPegawai() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.errMessage = 'Sedang mencari data ...'
            let tanggal = ''
            let bulan = ''
            let tahun = ''
            if(this.selectedFilterDate.value == 'T') {
                tanggal = this.date
            } else if(this.selectedFilterDate.value == 'B') {
                bulan = this.dates.monthIndex
                tahun = this.dates.year
            }
            let payload = {
                filter: this.inputSearch,
                limit: this.size,
                pageIn: this.page,
                tanggal: tanggal,
                tahun: tahun,
                bulan: bulan,
                tipe: this.selectedFilter.value,
                periode: this.selectedFilterDate.value
            }
            DataApi.post("dashboard/WFHWFO", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = parseInt(response.data.totalRow)
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errMessage = 'Maaf, Data Tidak Ditemukan'
                }
                this.flagSearch = false
                this.$emit('flags', 1)
            })
        },
        separators(val) {
            let value = val.toString()
            let leng = value.length
            let sisa 	= leng % 3
            let rupiah 	= value.substr(0, sisa)
            let ribuan 	= value.substr(sisa).match(/\d{3}/g)
                
            if (ribuan) {
                let separator = sisa ? '.' : ''
                rupiah += separator + ribuan.join('.')
            }
            return rupiah
        },
        getDataRole() {
            DataApi.get("pegawai/role/cek")
            .then( response => {
                let res = response.data
                if(res.success == true) {
                    this.admin = res.data.admin
                    if(this.admin != 'Y') {
                        this.selectedFilter.value = ''
                        this.selectedFilter.text = ''
                    } else {
                    }
                }
                this.getDataFilter()
                this.getDataPegawai()
                this.getDataFilterDate()
            })
        },
        getDataFilter() {
            if(this.admin == 'Y') {
                this.dataFilter = [
                    { text: 'Divisi', value: '1' },
                    { text: 'Bidang', value: '2' },
                    { text: 'Sub Bidang', value: '4' },
                    { text: 'Kantor', value: '3' }
                ]
            } else {
                this.dataFilter = []
            }
        },
        getDataFilterDate() {
            this.dataFilterDate = [
                { text: 'Harian', value: 'T' },
                { text: 'Bulanan', value: 'B' }
            ]
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getDataPegawai()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        showModal(id) {
            let temp = this.datas[id]
            let lvl = temp.lvl
            this.titleModal = temp.namaUnit
            let payload = ''
            let tanggal = ''
            let bulan = ''
            let tahun = ''
            if(this.selectedFilterDate.value == 'T') {
                tanggal = this.date
            } else if(this.selectedFilterDate.value == 'B') {
                bulan = this.dates.monthIndex
                tahun = this.dates.year
            }
            if(this.selectedFilter.value != '3') {
                payload = {
                    idKantor: '',
                    lvl: lvl,
                    status: '',
                    tanggal: tanggal,
                    bulan: bulan,
                    tahun: tahun,
                    tipe: this.selectedFilterDate.value
                }
            } else {
                payload = {
                    idKantor: lvl,
                    lvl: '',
                    status: '',
                    tanggal: tanggal,
                    bulan: bulan,
                    tahun: tahun,
                    tipe: this.selectedFilterDate.value
                }
            }
            DataApi.post("dashboard/tiga", payload)
            .then(res => {
                let response = res.data
                this.dataWfo = []
                this.dataWfh = []
                this.dataTidakPresensi = []
                this.dataLeave = []
                this.totalWfo = 0
                this.totalWfh = 0
                this.totalTidakPresensi = 0
                this.totalLeave = 0
                this.totalSemua = 0
                if(response.success == true) {
                    let temp = response.data
                    this.series[0] = temp.jumlah[0]
                    this.series[1] = temp.jumlah[1]
                    this.series[2] = temp.jumlah[3]
                    this.series[3] = temp.jumlah[4]
                    this.status = true
                    this.totalWfo = temp.jumlah[0]
                    this.totalWfh = temp.jumlah[1]
                    this.totalTidakPresensi = temp.jumlah[3]
                    this.totalLeave = temp.jumlah[4]
                    this.totalSemua = this.totalWfo + this.totalWfh + this.totalTidakPresensi + this.totalLeave
                    this.dataWfo = temp.daftarWfo
                    this.dataWfh = temp.daftarWfh
                    this.dataTidakPresensi = temp.daftarTidakPresensi
                    this.dataLeave = temp.daftarTidakMasuk
                } else {
                    this.series = []
                }
                this.detailModal = true
            })
        },
        getDownload(val) {
            this.$store.state.loadingScreen = true
            let indexs = []
            let ket = ''
            if(val == 'wfo') {
                indexs = this.dataWfo
                ket = ' WFO'
            } else if(val == 'wfh') {
                indexs = this.dataWfh
                ket = ' WFH'
            } else if(val == 'semua') {
                ket = ' WFO dan WFH'
            } else if(val == 'tidakPresensi') {
                ket = ' Tidak Melakukan Presensi'
                indexs = this.dataTidakPresensi
            } else if(val == 'leave') {
                ket = ' Izin atau Cuti atau Dinas'
                indexs = this.dataLeave
            }

            let unit = ' ' + this.titleModal

            let date = ' ' + this.date
            let fileName = 'Data' + ket + unit + date
            let data = []
            if(val == 'semua') {
                data = [
                    {
                        sheet: 'WFH',
                        columns: [
                            { label: 'Nama', value: 'namaPegawai'  },
                            { label: 'NIP', value: 'nik' },
                            { label: 'Jabatan', value: 'jabatan' },
                            { label: 'Tipe Pegawai', value: 'tipePegawai' },
                            { label: 'SUB BIDANG', value: 'subBidang' },
                            { label: 'BIDANG', value: 'bidang' },
                            { label: 'DIVISI', value: 'divisi' },
                            { label: 'DIREKTORAT', value: 'direktorat'},
                            { label: 'Status', value: 'status'},
                            { label: 'Tanggal', value: 'tanggalAbsen'},
                            { label: 'Nama Kantor Presensi Masuk', value: 'namaKantorMasuk'},
                            { label: 'Nama Kantor Presensi Keluar', value: 'namaKantorKeluar'},
                        ],
                        content: this.dataWfh
                    },
                    {
                        sheet: 'WFO',
                        columns: [
                            { label: 'Nama', value: 'namaPegawai'  },
                            { label: 'NIP', value: 'nik' },
                            { label: 'Jabatan', value: 'jabatan' },
                            { label: 'Tipe Pegawai', value: 'tipePegawai' },
                            { label: 'SUB BIDANG', value: 'subBidang' },
                            { label: 'BIDANG', value: 'bidang' },
                            { label: 'DIVISI', value: 'divisi' },
                            { label: 'DIREKTORAT', value: 'direktorat'},
                            { label: 'Status', value: 'status'},
                            { label: 'Tanggal', value: 'tanggalAbsen'},
                            { label: 'Nama Kantor Presensi Masuk', value: 'namaKantorMasuk'},
                            { label: 'Nama Kantor Presensi Keluar', value: 'namaKantorKeluar'},
                        ],
                        content: this.dataWfo
                    },
                    {
                        sheet: 'Tidak Presensi',
                        columns: [
                            { label: 'Nama', value: 'namaPegawai'  },
                            { label: 'NIP', value: 'nik' },
                            { label: 'Jabatan', value: 'jabatan' },
                            { label: 'Tipe Pegawai', value: 'tipePegawai' },
                            { label: 'SUB BIDANG', value: 'subBidang' },
                            { label: 'BIDANG', value: 'bidang' },
                            { label: 'DIVISI', value: 'divisi' },
                            { label: 'DIREKTORAT', value: 'direktorat'},
                            { label: 'Status', value: 'status'},
                            { label: 'Tanggal', value: 'tanggalAbsen'},
                            { label: 'Nama Kantor Presensi Masuk', value: 'namaKantorMasuk'},
                            { label: 'Nama Kantor Presensi Keluar', value: 'namaKantorKeluar'},
                        ],
                        content: this.dataTidakPresensi
                    },
                    {
                        sheet: 'Izin, Cuti, Dinas',
                        columns: [
                            { label: 'Nama', value: 'namaPegawai'  },
                            { label: 'NIP', value: 'nik' },
                            { label: 'Jabatan', value: 'jabatan' },
                            { label: 'Tipe Pegawai', value: 'tipePegawai' },
                            { label: 'SUB BIDANG', value: 'subBidang' },
                            { label: 'BIDANG', value: 'bidang' },
                            { label: 'DIVISI', value: 'divisi' },
                            { label: 'DIREKTORAT', value: 'direktorat'},
                            { label: 'Status', value: 'status'},
                            { label: 'Tanggal', value: 'tanggalAbsen'},
                            { label: 'Nama Kantor Presensi Masuk', value: 'namaKantorMasuk'},
                            { label: 'Nama Kantor Presensi Keluar', value: 'namaKantorKeluar'},
                        ],
                        content: this.dataLeave
                    },
                ]
            } else {
                data = [
                    {
                        sheet: ket,
                        columns: [
                            { label: 'Nama', value: 'namaPegawai'  },
                            { label: 'NIP', value: 'nik' },
                            { label: 'Jabatan', value: 'jabatan' },
                            { label: 'Tipe Pegawai', value: 'tipePegawai' },
                            { label: 'SUB BIDANG', value: 'subBidang' },
                            { label: 'BIDANG', value: 'bidang' },
                            { label: 'DIVISI', value: 'divisi' },
                            { label: 'DIREKTORAT', value: 'direktorat'},
                            { label: 'Status', value: 'status'},
                            { label: 'Tanggal', value: 'tanggalAbsen'},
                            { label: 'Nama Kantor Presensi Masuk', value: 'namaKantorMasuk'},
                            { label: 'Nama Kantor Presensi Keluar', value: 'namaKantorKeluar'},
                        ],
                        content: indexs
                    }
                ]
            }
            
            let settings = {
                fileName: fileName
            }
            xlsx(data, settings)

            this.$store.state.loadingScreen = false
        },
        exportXLS() {
            this.$store.state.loadingScreen = true
            let tanggal = ''
            let bulan = ''
            let tahun = ''
            if(this.selectedFilterDate.value == 'T') {
                tanggal = this.date
            } else if(this.selectedFilterDate.value == 'B') {
                bulan = this.dates.monthIndex
                tahun = this.dates.year
            }
            let payload = {
                filter: this.inputSearch,
                limit: this.totalRow,
                pageIn: 1,
                tanggal: tanggal,
                tahun: tahun,
                bulan: bulan,
                tipe: this.selectedFilter.value,
                periode: this.selectedFilterDate.value
            }
            DataApi.post("dashboard/WFHWFO", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let temp = response.data.data
                    let fileName = 'Data WFH dan WFO ' + this.date
                    let data = [
                        {
                            sheet: 'Data WFH dam WFO',
                            columns: [
                                { label: 'Nama Tim', value: 'namaUnit'  },
                                { label: 'Total Pegawai', value: 'totalPegawai'  },
                                { label: 'Total Presensi', value: 'totalAbsen'  },
                                { label: 'Total Tidak Presensi', value: 'totalTidakAbsen'  },
                                { label: 'Total Izin/Cuti/Dinas', value: 'totalTidakMasuk'  },
                                { label: 'Total Work From Home', value: 'wfh'  },
                                { label: 'Total Work From Office', value: 'wfho'  },
                                { label: 'Persentase Tidak Presensi', value: 'persenTidakAbsen'  },
                                { label: 'Persentase Izin/Cuti/Dinas', value: 'persenTidakMasuk'  },
                                { label: 'Persentase Work From Home', value: 'persenWfh'  },
                                { label: 'Persentase Work From Office', value: 'persenWfo'  },
                            ],
                            content: temp
                        }
                    ]            
                    let settings = {
                        fileName: fileName
                    }
                    xlsx(data, settings)
                }
                this.$store.state.loadingScreen = false
            })
        },
        setDate() {
            let month = this.tanggal.getMonth() + 1
            let year = this.tanggal.getFullYear()
            this.dates.monthIndex = month
            this.dates.year = year
        },
        showDate(date) {
            this.dates = date
        }
    },
    mounted() {
        this.getDataRole()
        this.setDate()
    },
    computed: {
    },
}
</script>
<style scoped>
.card-title {
    font-size: 18px;
    color: rgba(0, 0, 0, 1);
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.modal-buttons {
    width:156px;
    height: 36px;
}
::v-deep .month-picker__container {
    z-index: 5 !important;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
}
::v-deep .month-picker__year button {
    width: 50px;
    height: 48px;
}
::v-deep .month-picker-input {
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    background-clip: padding-box;
    border: 1px solid;
    color: #768192;
    border-color: #d8dbe0;
    background-color: #f9fafc;
    border-radius: .25rem;
}
::v-deep .month-picker-input-container {
    width: 100%;
    min-width: none;
}
</style>